import { Pipe, PipeTransform } from '@angular/core';
import { BUSINESS_UNIT_ID_REPLACEMENT_KEY } from '../properties/sidebar.properties';

/**
 * Pipe that is used to replace `businessUnitId` hardcoded value with actual user businessUnitId
 */
@Pipe({
  name: 'replaceBusinessUnitId',
  standalone: true,
})
export class ReplaceBusinessUnitIdPipe implements PipeTransform {
  private readonly businessUnitIdReplacementKey = BUSINESS_UNIT_ID_REPLACEMENT_KEY;

  transform(routerLink: string | undefined, businessUnitId: string): string | undefined {
    if (!routerLink || !businessUnitId) {
      return routerLink;
    }

    return routerLink.replace(this.businessUnitIdReplacementKey, businessUnitId);
  }
}
